import React, {Component} from 'react';

//css
import styles from '../../../static/css/layoutStyleModules/manipulateHeader.module.scss';

import SvgIconBaseComponent from '../../svgIconComponents/SvgIconBaseComponent.js';

export default class ManipulateHeader extends Component {
    constructor(props){
        super(props);
        this.state = {

        };
    }

    leftButtonClicked = (event) => {
        event.stopPropagation();
        if(this.props.onLeftButtonClick !== undefined){
            this.props.onLeftButtonClick();
        }
    }

    rightButtonClicked = (event) => {
        event.stopPropagation();
        if(this.props.onRightButtonClick !== undefined){
            this.props.onRightButtonClick();
        }
    }

    render() {
        return (
          <div className={styles['headerWholeArea']}>
            <div className={styles['headerLeftBox'] + ' touchActivePush'}
            onClick={this.leftButtonClicked}>
              <SvgIconBaseComponent 
              image={this.props.leftIcon === undefined ? 'none' : this.props.leftIcon} 
              fillColor={this.props.leftIconColor === undefined ? '#666666' : this.props.leftIconColor} />
            </div>
            <div className={styles['headerCenterBox']}>
            </div>
            <div className={styles['headerRightBox'] + ' touchActivePush'}
            onClick={this.rightButtonClicked}>
              <SvgIconBaseComponent 
              image={this.props.rightIcon === undefined ? 'none' : this.props.rightIcon} 
              fillColor={this.props.rightIconColor === undefined ? '#666666' : this.props.rightIconColor} />
            </div>
          </div>
        )
    }
}
